import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { SkyDialogWithAttachmentsAndOptionsComponent } from './components/sky-dialog-with-attachments-and-options/sky-dialog-with-attachments-and-options.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { DsDialogModule } from '@skyeng/libs/shared/ui-kit-v2/dialog';
import { DsButtonModule } from '@skyeng/libs/shared/ui-kit-v2/button';
import { DsSpinnerModule } from '@skyeng/libs/shared/ui-kit-v2/spinner';
import { ReactiveFormsModule } from '@angular/forms';
import { DsNotificationModule } from '@skyeng/libs/shared/ui-kit-v2/notification';
import { DsTooltipModule } from '@skyeng/libs/shared/ui-kit-v2/tooltip';
import { DsInputModule } from '@skyeng/libs/shared/ui-kit-v2/input';
import { SkyUiNativeScrollModule } from '@skyeng/libs/shared/ui-kit';
import { DsTabsModule } from '@skyeng/libs/shared/ui-kit-v2/tabs';
import { DsIconModule } from '@skyeng/libs/shared/ui-kit-v2/icon';
import { SkyMiscModule } from '@skyeng/libs/shared/misc';
import { DropFilesZoneModule } from '@skyeng/libs/math/shared/misc';
import { DsSelectModule } from '@skyeng/libs/shared/ui-kit-v2/select';
import { MaRoundButtonModule } from '@skyeng/libs/math/shared/round-button';
import { DsCheckboxModule } from '@skyeng/libs/shared/ui-kit-v2/checkbox';

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    OverlayModule,
    DsDialogModule,
    DsButtonModule,
    DsSpinnerModule,
    ReactiveFormsModule,
    DsNotificationModule,
    DsTooltipModule,
    DsInputModule,
    SkyUiNativeScrollModule,
    DsTabsModule,
    DsIconModule,
    SkyMiscModule,
    DropFilesZoneModule,
    DsCheckboxModule,
    MaRoundButtonModule,
    DsSelectModule,
  ],
  declarations: [SkyDialogWithAttachmentsAndOptionsComponent],
  exports: [SkyDialogWithAttachmentsAndOptionsComponent],
})
export class SkyDialogWithAttachmentsAndOptionsModule {}
